'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from 'react-error-boundary';
import { SmartErrorState } from './smart-error-state';
import type { LucideIcon } from 'lucide-react';
interface ErrorBoundaryWithPresetsProps {
  children: React.ReactNode;
  icon?: LucideIcon;
  title?: string;
  description?: string;
  className?: string;
}
function ErrorBoundaryWithPresets(t0) {
  const $ = _c(8);
  const {
    children,
    icon,
    title,
    description,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== description || $[2] !== icon || $[3] !== title) {
    t1 = <SmartErrorState icon={icon} title={title} description={description} className={className} />;
    $[0] = className;
    $[1] = description;
    $[2] = icon;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== t1) {
    t2 = <ErrorBoundary fallback={t1}>{children}</ErrorBoundary>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { ErrorBoundaryWithPresets };